import { SingleFooterItem } from './SingleFooterItem';
import type { FooterItemProps } from '../types';

export const FooterItems = ({ footerItems }: { footerItems: FooterItemProps[] }) => {
  return (
    <div className="order-summary-container__footer-items">
      {footerItems.map(({ id, ...item }) => (
        <SingleFooterItem key={id} {...item} />
      ))}
    </div>
  );
};
